import { SSM_PRE_SEATS_FAKE_PUBLIC_PORTAL_GATE } from 'pricing-pages-lib/constants/Gates';
import { useEffect } from 'react';
import { SSM0002_GROUP_PARAMETER_KEY, SSM0002_GROUP_PARAMETER_OPTIONS, SSM0002_TREATMENT_KEY } from '../../constants/experimentKeys';
import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { areExperimentsLoadingSelector, experimentByTreatmentKeySelector, hasExperimentsFetchSucceededSelector } from '../../selectors/ExperimentSelectors';
import { isUngatedSelector } from '../../selectors/GatingSelectors';
import { laboratoryClient } from '../laboratoryClient';
import { getIsAcceptanceTest } from '../testUtils';
const treatmentKey = SSM0002_TREATMENT_KEY;
const groupParameterKey = SSM0002_GROUP_PARAMETER_KEY;
const groupParameterOptions = SSM0002_GROUP_PARAMETER_OPTIONS;
export const logSSM0002Exposure = () => {
  laboratoryClient.logExposure(treatmentKey);
};
export const SSM0002ExperimentSelector = state => {
  const isAcceptanceTest = getIsAcceptanceTest();
  const isAppAuth = isAppAuthSelector(state);
  const isPreSeatsFakePublicPortal = isUngatedSelector(state, {
    gateKey: SSM_PRE_SEATS_FAKE_PUBLIC_PORTAL_GATE
  });
  const experiment = experimentByTreatmentKeySelector(state, treatmentKey);
  const areExperimentsLoading = areExperimentsLoadingSelector(state);
  const hasExperimentsFetchSucceeded = hasExperimentsFetchSucceededSelector(state);
  const isEligibleForExperiment = !isAcceptanceTest && isAppAuth && !isPreSeatsFakePublicPortal && hasExperimentsFetchSucceeded;
  const experimentCohort = experiment === null || experiment === void 0 ? void 0 : experiment.parameters[groupParameterKey];
  const isControl = isEligibleForExperiment && experimentCohort === groupParameterOptions.control;
  const isVariant = isEligibleForExperiment && experimentCohort === groupParameterOptions.variant;
  return {
    isEligibleForSSM0002: isEligibleForExperiment,
    isSSM0002Control: isControl,
    isSSM0002Variant: isVariant,
    isSSM0002Fetched: hasExperimentsFetchSucceeded,
    isSSM0002Loading: areExperimentsLoading
  };
};
export const useSSM0002Experiment = () => {
  const experiment = useAppSelector(SSM0002ExperimentSelector);
  const {
    isEligibleForSSM0002,
    isSSM0002Fetched
  } = experiment;
  useEffect(() => {
    if (isEligibleForSSM0002 && isSSM0002Fetched) {
      logSSM0002Exposure();
    }
  }, [isEligibleForSSM0002, isSSM0002Fetched]);
  return experiment;
};